import React from 'react';
import { Box, Container, Typography, Link, Stack, Divider } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  const navLink = (label, path) => (
    <Link
      component="button"
      type="button"
      onClick={() => navigate(path)}
      underline="hover"
      color="text.secondary"
      sx={{ fontSize: '0.875rem' }}
    >
      {label}
    </Link>
  );

  return (
    <Box
      component="footer"
      sx={{
        mt: 8,
        py: 4,
        borderTop: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={2}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', sm: 'center' }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <LockOutlinedIcon sx={{ color: 'primary.main', fontSize: 20 }} />
            <Typography variant="body2" color="text.secondary">
              Encrypted in your browser. We never see your secret.
            </Typography>
          </Box>
          <Stack direction="row" spacing={3} flexWrap="wrap">
            {navLink('FAQ', '/faq')}
            {navLink('API Docs', '/api/docs')}
            {navLink('Terms of Use', '/terms-of-use')}
            {navLink('Privacy Policy', '/data-privacy')}
          </Stack>
        </Stack>
        <Divider sx={{ my: 2 }} />
        <Typography variant="caption" color="text.secondary">
          © {new Date().getFullYear()} Share-a-Secret · Zero-knowledge, end-to-end encrypted secret sharing.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
